"use client"

import { getLiveTotalScore } from "@/helpers/getters"
import { type LiveStatistics } from "@azuro-org/sdk"
import cx from "classnames"

export type OvertimeTotalScoreProps = {
  className?: string
  sportId: string
  scoreBoard: LiveStatistics["scoreBoard"]
  liveScore: any
}

const OvertimeTotalScore: React.FC<OvertimeTotalScoreProps> = ({
  className,
  sportId,
  scoreBoard,
  liveScore,
}) => {
  console.log({ inside: "OvertimeTotalScore", sportId, scoreBoard, liveScore })
  if (!liveScore) {
    return null
  }
  //   if (!scoreBoard) {
  //     return null
  //   }

  //   const scoreValue = getLiveTotalScore(sportId, scoreBoard)
  console.log({ liveScore })
  //   if (!scoreValue) {
  //     return null
  //   }

  return (
    <div
      className={cx(
        "bg-card-border-bottom p-px rounded-full overflow-hidden w-fit flex-none mx-1 text-caption-13 font-semibold",
        className
      )}
    >
      <div className="bg-bg-l3 rounded-full py-1 px-2 w-fit">
        {liveScore.homeScore}
        <span className="text-grey-70 mx-1.5">:</span>
        {liveScore.awayScore}
      </div>
    </div>
  )
}

export default OvertimeTotalScore
